"use client";
import { Spin } from "antd";
import classNames from "classnames";
import React from "react";
import styles from "./style.module.scss";

interface LoadingProps {
  isLoading?: boolean;
  size?: "small" | "default" | "large";
  fullScreen?: boolean;
  text?: React.ReactNode;
}

export const Loader: React.FC<React.PropsWithChildren<LoadingProps>> = ({
  isLoading = true,
  fullScreen,
  text,
  ...props
}) => {
  return (
    <div
      className={classNames({
        [styles.fullScreen]: fullScreen,
        [styles.center]: !fullScreen,
      })}
    >
      <Spin {...props} />
      {text}
    </div>
  );
};

export const Loading = () => {
  return (
    <div className={styles.alignCenter}>
      <Spin size="large" />
    </div>
  );
};

export default Loading;
